import axios from 'axios';

export default {
  state: {
    promocode: [],
    loading: false,
    error: null,
    promocodeLoaded: false,
    promocodeLoading: false
  },
  mutations: {
    SET_PROMOCODE(state, promocode) {
      state.promocode = promocode.data;
      state.promocodeLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    DEL_PROMOCODE_ITEM(state, id) {

      for (let i in state.promocode_items) {
        if (state.promocode_items[i].id == id)
          state.promocode_items[i].delete = true
      }

    },
    SET_PROMOCODE_LOADING(state, status) {
      state.promocodeLoading = status;
    },
    SET_PROMOCODE_ERROR(state, error) {
      state.promocodeError = error;
    },
    UNSET_PROMOCODE(state) {
      state.promocodeLoaded = false;
      state.promocodeLoading = false;
      state.promocode = [];
    },
  },
  actions: {
    async fetchPromocode({ commit, state }, reload=false) {
      if (!reload)
      commit('UNSET_PROMOCODE');
      try {
        commit('SET_PROMOCODE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/order/promocode/');
        commit('SET_PROMOCODE', response.data);
        commit('SET_PROMOCODE_ERROR', null);
      } catch (error) {
        commit('SET_PROMOCODE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching promocode:', error);
      } finally {
        commit('SET_PROMOCODE_LOADING', false);
      }
    },
    async addPromocode({ commit, state, dispatch }, promocode) {

      try {
        //commit('DEL_PROMOCODE_ITEM', id);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/order/promocode/', {coupon:promocode},
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.data) {
          dispatch('fetchPromocode', true);
          dispatch('fetchBasket', true);
        }

        commit('SET_PROMOCODE_ERROR', null);
      } catch (error) {
        commit('SET_PROMOCODE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching promocode:', error);
      } finally {
        commit('SET_PROMOCODE_LOADING', false);
      }
    },
    async removePromocode({ commit, state, dispatch }, promocode) {

      try {
        //commit('DEL_PROMOCODE_ITEM', promocode);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.post('api/order/promocode/remove/', {coupon:promocode},
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.data) {
          dispatch('fetchPromocode', true);
          dispatch('fetchBasket', true);
        }

        commit('SET_PROMOCODE_ERROR', null);
      } catch (error) {
        commit('SET_PROMOCODE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching promocode:', error);
      } finally {
        commit('SET_PROMOCODE_LOADING', false);
      }
    }
  },
  getters: {
    promocode: state => state.promocode,
    promocodeLoading: state => state.promocodeLoading,
    promocodeError: state => state.promocodeError,
    promocodeLoaded: state => state.promocodeLoaded
  }
}